











import { Component, Prop, Vue } from 'vue-property-decorator';
import { VISIBILITY_COLORS } from '@/lib/kbConstants';
import KBVisbility from '@/models/KnowledgeBase/KBVisibility';

@Component({
  name: 'KBVisibilityBadge'
})
export default class KBVisibilityBadge extends Vue {
  @Prop({ required: true })
  public visibility!: string;

  public get visibilityColor(): string {
    return VISIBILITY_COLORS[this.visibility] || 'grey';
  }

  public get visibilityText(): string {
    switch (this.visibility) {
      case KBVisbility.Internal:
        return 'Internal';
      case KBVisbility.External:
        return 'External';
      default:
        return this.visibility;
    }
  }

  public get visibilityIcon(): string {
    switch (this.visibility) {
      case KBVisbility.Internal:
        return 'mdi-lock';
      case KBVisbility.External:
        return 'mdi-account-group';
      default:
        return 'mdi-eye';
    }
  }
}
